<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

const route = useRoute()

const handleNextStep = async () => {
  await handleNext('tutorial_resources_overview')
}

const isOnResourcesSection = computed(() => {
  return route.path.startsWith('/resources')
})
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        The resource page has a lot going on, lets unravel it!
      </p>
      <p class="pb-2">
        Resources flow from the top to the bottom, as you can see some of your planets might already have started producing ore, these are stored in your empire and are available everywhere.
      </p>
      <p class="pb-2">
        These ores are called level 1 ores, you will notice that more ore/materials are available below, these are the level 2,3,4 etc ores.
      </p>
      <p class="pb-2">
        You can build harvesters <GenericIcon type="ore"/> and ore storage <GenericIcon type="ore_storage"/> to speed up ore mining and its storage.
      </p>
    </template>

    <template #alerts>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        Got it!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>